// src/sections/Section13.jsx
import React, { useState, useEffect } from "react";
import "../styles/variables.css";

import { Swiper, SwiperSlide } from "swiper/react";
// importa Navigation dal path modules
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const Section13 = ({ contenuti }) => {
  const contenutiArray = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);


  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//e.issuu.com/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {contenutiArray.map((content, index) => {
        const {
          titolo_1: titolo1,
          titolo_2: titolo2,
          descrizione_it: descrizione,
          immagini_aggiuntive: immagini = [],
          link_it: link,
          call_to_action_it: button
        } = content;

        return (
          <div
            key={index}
            className="container-fluid my-5 py-5"
            style={{ padding: "32px 16px", gap: "16px" }}
            id="volantino"
          >
            {/* Titoli */}
            <div className="title-section text-center mb-4">
              <h2
                className={`black-text ${isMobile
                  ? "d-block d-lg-none title-section-mobile"
                  : "d-none d-lg-block title-section"
                  }`}
              >
                {titolo1}
              </h2>
              <h2
                className={`green-text ${isMobile
                  ? "d-block d-lg-none title-section-mobile"
                  : "d-none d-lg-block title-section"
                  }`}
              >
                {titolo2}
              </h2>
            </div>

            {/* Descrizione */}
            <div className="container mb-4">
              <p
                className="custom-text two-column-text"
                dangerouslySetInnerHTML={{ __html: descrizione }}
              />
              { button && 
                <div className="d-flex justify-content-start mt-3">
                  <a target="_blank" href="https://maps.app.goo.gl/hTwx5ByauJGn2dvc7">
                    <div className="btn btn btn-three d-inline-block">Scopri di più</div>
                  </a>
                </div>
              }
            </div>

            {/* Swiper con navigazione */}
            <div className="container">
              <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={20}
                slidesPerView={1}
                className="mySwiper"
              >
                {immagini.map((img) => (
                  <SwiperSlide key={img.ID}>
                    {img.titolo_it ? (
                      <a href={img.titolo_it}>
                        <img
                          src={img.immagine_path}
                          alt={img.descrizione || ""}
                          className="img-fluid"
                          style={{ width: "100%" }}
                        />
                      </a>
                    ) : (
                      <img
                        src={img.immagine_path}
                        alt={img.descrizione || ""}
                        className="img-fluid"
                        style={{ width: "100%" }}
                      />
                    )}
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            {link && <div className="container my-4">
              <div style={{ width: '100%', height: '60vh' }}>
                <iframe
                  src={link}  // <-- metti qui il tuo link esatto
                  width="100%"
                  height="100%"
                  style={{ border: 'none' }}
                  allowFullScreen
                ></iframe>
              </div>
            </div>}
            

          </div>
        );
      })}
    </>
  );
};

export default Section13;
